<template>
  <div>
    <vs-table stripe pagination max-items="5" search :data="menus">
      <template slot="header">
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          @click="add"
          >Agregar</vs-button
        >
      </template>
      <template slot="thead">
        <vs-th>Nombre</vs-th>
        <vs-th>Icono</vs-th>
        <vs-th>Ruta</vs-th>
        <vs-th>Orden</vs-th>
        <vs-th>Parent</vs-th>
        <vs-th>Estado</vs-th>
        <vs-th class="grid justify-items-center">
          <div class="text-center">Acciones</div>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.men_name">
            {{ tr.men_name }}
          </vs-td>

          <vs-td :data="tr.men_icon">
            {{ tr.men_icon }}
          </vs-td>

          <vs-td :data="tr.men_route">
            {{ tr.men_route }}
          </vs-td>

          <vs-td :data="tr.men_order">
            {{ tr.men_order }}
          </vs-td>

          <vs-td :data="tr.men_parent">
            {{ tr.men_parent }}
          </vs-td>

          <vs-td :data="tr.men_status">
            <vs-chip v-if="tr.men_status == 1" color="primary">Activo</vs-chip>
            <vs-chip v-else color="danger">Off</vs-chip>
          </vs-td>
          <vs-td class="">
            <div class="grid grid-cols-2 justify-items-center">
              <vs-button
                radius
                color="warning"
                type="flat"
                icon-pack="feather"
                icon="icon-edit"
                @click="edit(tr)"
              ></vs-button>
              <!-- <vs-button
                radius
                color="danger"
                type="flat"
                icon-pack="feather"
                icon="icon-trash"
                @click="trash(tr)"
              ></vs-button> -->
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
    };
  },
  computed: {
    menus() {
      return this.$store.state.lists.table_menu;
    },
  },
  methods: {
    add() {
      let display = {
        table: false,
        add: true,
        edit: false,
      };
      this.$store.commit("menu/trash_menu");
      this.$emit("screen", display);
    },
    edit(item) {
      this.$store.commit("menu/set_men_id", item.men_id);
      this.$store.commit("menu/set_men_order", item.men_order);
      this.$store.commit("menu/set_men_name", item.men_name);
      this.$store.commit("menu/set_men_name_en", item.men_name_en);
      this.$store.commit("menu/set_men_name_pr", item.men_name_pr);
      this.$store.commit("menu/set_men_route", item.men_route);
      this.$store.commit("menu/set_men_param", item.men_param);
      this.$store.commit("menu/set_men_icon", item.men_icon);
      this.$store.commit("menu/set_men_isadmin", item.men_isadmin);
      this.$store.commit("menu/set_men_parent", item.men_parent);
      this.$store.commit("menu/set_men_status", item.men_status);
      let display = {
        table: false,
        add: false,
        edit: true,
      };
      this.$emit("screen", display);
    },
    trash(item) {
      console.log(item);
    },
  },
};
</script>
